var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusNearbyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "114.601689%",
    x2: "50%",
    y2: "-8.9651601%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33289B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86DD7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", {
    id: "alef",
    transform: "translate(104.000000, 98.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Smooth-Corners",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.141456,-5.90428975e-15 C95.3248882,3.43056238e-15 76.8975727,5.29105984 58.3197949,15.2265641 C39.7420171,25.1620684 25.1620684,39.7420171 15.2265641,58.3197949 C5.29105984,76.8975727 -2.28704159e-15,95.3248882 3.93619317e-15,146.141456 L0,0 L146.141456,0 Z M365.858544,0 L512,0 L512,146.141456 C512,95.3248882 506.70894,76.8975727 496.773436,58.3197949 C486.837932,39.7420171 472.257983,25.1620684 453.680205,15.2265641 C435.102427,5.29105984 416.675112,-3.43056238e-15 365.858544,5.90428975e-15 Z M512,365.858544 L512,512 L365.858544,512 C416.675112,512 435.102427,506.70894 453.680205,496.773436 C472.257983,486.837932 486.837932,472.257983 496.773436,453.680205 C506.70894,435.102427 512,416.675112 512,365.858544 Z M146.141456,512 L0,512 L0,365.858544 C2.28704159e-15,416.675112 5.29105984,435.102427 15.2265641,453.680205 C25.1620684,472.257983 39.7420171,486.837932 58.3197949,496.773436 C76.8975727,506.70894 95.3248882,512 146.141456,512 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.929688,96 L246.765845,162.371134 C251.528084,168.938558 261.199377,170.725363 268.367283,166.362074 C269.543664,165.645981 285.206627,144.351209 315.356173,102.477758 C318.232643,98.4366611 323.142117,96 328.407795,96 L381.940111,96 C391.881237,96 399.940111,104.058875 399.940111,114 C399.940111,117.808061 398.732396,121.518011 396.490653,124.596308 L315.356173,236.007813 C311.635869,240.860112 305.986463,251.091069 309.617188,256 L398.433992,387.948829 C403.9851,396.195717 401.799739,407.381204 393.552851,412.932312 C390.582193,414.931908 387.082627,416 383.501679,416 L308.742025,416 C302.489149,416 296.684264,412.75496 293.408962,407.428531 L139.530036,157.184326 C134.742478,150.632374 125.064349,148.876916 117.913329,153.263402 C113.593065,155.913483 111,160.363214 111,165.126761 L111,401.723391 C111,409.608144 117.976285,416 126.581969,416 L192.929688,416 C199.00482,416 203.929687,411.075132 203.929688,405 C203.929688,392.263021 203.929688,379.526042 203.929688,366.789063",
    id: "x",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    fillOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusNearbyIcon);
export default __webpack_public_path__ + "static/media/BusNearbyIcon.5a526eddb90e78f7468ce9d574ca4af8.svg";
export { ForwardRef as ReactComponent };